import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import RestoreWallet from './pages/RestoreWallet';
import ImportWallet from './pages/ImportWallet';
import LegacyWallet from './pages/LegacyWallet';


const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/restore",
    element: <RestoreWallet />,
  },
  {
    path: "/import",
    element: <ImportWallet />,
  },
  {
    path: "/legacy",
    element: <LegacyWallet />,
  },
]);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

reportWebVitals();
